import { Box, Container, Grid, Link, Typography } from '@mui/material';
//import trustelement from '../../assets/trustelement.svg';
import trustelementklein from '../../assets/trustelement_tuev_klein.png';
import { AppState, DefaultProps } from '../../types/types';
import Unsubscribe from "../inbox/Unsubscribe";
import ContactChangelink from "../../pages/account/ContactChangelink";
import pfeilrechts from '../../assets/images/pfeilrechts.svg';

interface TrustelementProps extends DefaultProps {
    appState: AppState,
}




function Trustelement(props: TrustelementProps) {

    let kontaktdatenAendernAnzeigen = true;
    let flixcheckUrl = props.appState?.customizing?.technischeUnterstuetzung || 'https://check.rheinland-versicherungen.de/api/v1/widget/wbRxhxBphbJmVfsvvGCJmdRVJRSwqYVJ/transactions/redirect/';

    return (
        <Box
            sx={{
                backgroundColor: props.appState?.customizing?.colors?.trustElementBackgroundColor || '#fafafa',

                borderBottomColor: props.appState?.customizing?.colors?.backgroundColor || '#ffffff',
                bottom: {
                    xs: 118,
                    sm: 118,
                    md: 118,
                    lg: 39,
                    xl: 39
                },
                //bottom: 118,
                padding: 0,
                margin: 0,
                width: '100%',
                overflowX: 'hidden',
                overflowY: 'hidden',
                paddingTop: '24px',
                textAlign: 'center',
            }}>
            {/*
            ======================
            Anfang Desktop Ansicht
            ======================
            */}
            <Container maxWidth="lg" sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex' } }} >
                <Grid container spacing={2}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        width: '100%',
                        "& img": {
                            flexGrow: 1
                        }
                    }}>
                        {/*
                        <img src={trustelement} height="70" width="171" alt="Ihre Daten sind bei uns sicher!" />
                        */}

                        <Box className="padding-x-3" sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: 2,
                            textAlign: 'left',
                            "& span": {
                                color: '#FFFFFF',
                                fontWeight: 200,
                                fontSize: '14px'
                            },
                            "& a": {
                                color: '#FFFFFF'
                            }
                        }}>

                        </Box>


                        <Box className="padding-x-3" sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: 2,
                            textAlign: 'left',
                            "& span": {
                                color: '#FFFFFF',
                                fontWeight: 200,
                                fontSize: '1rem'
                            },
                            "& a": {
                                color: '#FFFFFF'
                            }
                        }}>
                          
                                <Typography className='AktionHeader'>Aktionen</Typography>
                                <span><Link sx={{ textDecoration: 'none' }} href={flixcheckUrl} target='_blank' rel="noreferrer"><Box sx={{ fontSize: "1.0rem", display: 'flex-inline' }}><img src={pfeilrechts} alt="Pfeil" className={"aktionPfeilRechts"} /> Technische Unterstützung</Box></Link></span>
                                {kontaktdatenAendernAnzeigen &&<ContactChangelink />}
                                <Unsubscribe />
                                
                          
                        </Box>

                        <Box sx={{
                            "& img": {
                                maxHeight: '106px'
                            },
                            textAlign: 'center',
                            flexGrow: 1
                        }}>
                            <img src={trustelementklein} alt="TÜV zertifiziert" />
                        </Box>
                    </Box>
                </Grid>
            </Container>
            {/*
            ======================
            Ende Desktop Ansicht
            ======================
            ======================
            Anfang Mobile Ansicht
            ======================
            */}

            <Container maxWidth="lg" sx={{ display: { xs: 'flex', sm: 'flex', md: 'none', lg: 'none' } }} >
                <Grid container spacing={1}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'left',
                        flexWrap: 'wrap',
                        width: '100%',
                        "& img": {
                            flexGrow: 1
                        }
                    }}>
                        <Box className="padding-x-3" sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: 1,

                            flexBasis: '80%',
                            textAlign: 'left',
                            marginLeft: "20px",
                            lineHeight: "0.7em",
                            marginBottom: "1em",
                            "& span": {
                                color: '#FFFFFF',
                                fontWeight: 100,
                                fontSize: '1em'
                            },
                            "& a": {
                                color: '#FFFFFF'
                            },

                        }}>

                            <Typography className='AktionHeader'>Aktionen</Typography><br />
                            <span><Link sx={{ textDecoration: 'none' }} href={flixcheckUrl} target='_blank' rel="noreferrer"><Box sx={{ fontSize: "1.0rem", display: 'flex-inline' }}><img src={pfeilrechts} alt="Pfeil" className={"aktionPfeilRechts"} /> Technische Unterstützung</Box></Link></span>
                            <Box sx={{ marginTop: "1em" }}>
                            {kontaktdatenAendernAnzeigen &&<ContactChangelink />}
                               
                            </Box>
                            <Box sx={{ marginTop: "1em" }}>
                            <Unsubscribe />
                            </Box>

                        </Box>

                        <Box sx={{
                            "& img": {
                                maxHeight: '106px'
                            },
                            textAlign: 'left',
                            flexGrow: 1
                        }}>

                        </Box>

                        <Box sx={{
                            "& img": {
                                maxHeight: '100px'
                            },
                           
                            flexGrow: 1,
                            marginTop: "0.2em"
                        }}>
                            <img src={trustelementklein}  alt="TÜV zertifiziert" />
                        </Box>


                    </Box>

                    <Box sx={{
                        "& img": {
                            maxHeight: '10px'
                        },
                        textAlign: 'center',
                        flexGrow: 1,
                        paddingLeft: '0.5rem'

                    }}>
                        <hr />
                    </Box>

                </Grid>


            </Container>
            {/*
            ======================
            Ende Mobile Ansicht
            ======================
            */}

        </Box>
    );
}
export default Trustelement;